import React, { Component } from "react";

//Components
import ProductHeader from "../../ProductDetails/ProductHeader";
import Snackbar from "@material-ui/core/Snackbar";
import ActionButton from "../../ActionButton";
import MuiAlert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";

//Assets
import { ReactComponent as Success } from "./success.svg";
import AssignmentIcon from "@material-ui/icons/Assignment";
import MyLocationIcon from "@material-ui/icons/MyLocation";

//Redux
import { connect } from "react-redux";
import { Redirect } from "react-router";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class index extends Component {
  state = {
    open: false,
    drawerOpen: false,
  };

  toggleDrawer = (state) => {
    this.setState({ drawerOpen: state });
  };

  render() {
    const language = this.props.language;

    if (!this.props.history.location.state) return <Redirect to="/" />;

    const tracking_id = this.props.history.location.state.tracking_id;

    const copyToClipboard = () => {
      const textField = document.createElement("textarea");
      textField.innerText = tracking_id;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand("copy");
      textField.remove();
    };

    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      this.setState({ open: false });
    };

    return (
      <div style={{ backgroundColor: "white", minHeight: window.innerHeight }}>
        <ProductHeader
          onBack={() => {
            this.props.history.goBack();
          }}
        />

        <Snackbar
          open={this.state.open}
          autoHideDuration={3000}
          onClose={handleClose}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert onClose={handleClose} severity="success">
            {language == "english"
              ? "Code copied successfully!"
              : "تم نسخ رقم التتبع"}
          </Alert>
        </Snackbar>

        <div className="free-space-160-white"></div>

        <Success width="100" height="100" />

        <p
          className="mt-4"
          style={{ fontSize: "1rem" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {language == "english"
            ? "Your order has been placed successfully!"
            : "لقد تم وضع طلبك بنجاح!"}
        </p>

        <p
          className="mt-4"
          style={{ fontSize: "1rem" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {language == "english"
            ? "Your order tracking code is:"
            : "رقم تتبع طلبك هو:"}{" "}
          <span style={{ fontWeight: 600 }}>{tracking_id}</span>
        </p>

        <Button
          variant="contained"
          className="mt-4"
          color="primary"
          disableElevation
          onClick={() => {
            copyToClipboard();
            this.setState({ open: true });
          }}
          endIcon={language == "english" ? <AssignmentIcon /> : null}
          startIcon={language == "arabic" ? <AssignmentIcon /> : null}
        >
          {language == "english" ? "Copy Code" : "نسخ رقم التتبع"}
        </Button>

        {this.props.settings.enable_tracking && (
          <div style={{ display: "block", marginTop: 10 }}>
            <Button
              variant="contained"
              className="mt-4 mx-auto"
              color="primary"
              disableElevation
              onClick={() => {
                this.props.history.replace("/distributor/track/order/", {
                  trackingCode: tracking_id,
                });
              }}
              endIcon={language == "english" ? <MyLocationIcon /> : null}
              startIcon={language == "arabic" ? <MyLocationIcon /> : null}
            >
              {language == "english" ? "Track Order" : "تتبع الطلب"}
            </Button>
          </div>
        )}

        <div className="free-space-80-white"></div>

        <ActionButton
          b2b={true}
          action={
            language == "english"
              ? "Back to shopping"
              : "العودة الى القائمة الرئيسية"
          }
          onClick={() => {
            this.props.history.goBack();
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(index);
